/**
 * MensagensNaoLidasWidget — Total de mensagens WhatsApp nao lidas
 * (conversas ABERTAS com nao_lidas_count > 0).
 */
import React from "react";
import { Link } from "react-router-dom";

import { listarConversas } from "../../../services/whatsapp";

import { CardBody, KpiValor, KpiSub, LinkLight, CardFooter } from "../styles";


export const meta = {
  id: "whatsapp_nao_lidas",
  label: "WhatsApp não lidas",
  descricao: "Total de mensagens WhatsApp não lidas em conversas abertas.",
  categoria: "WhatsApp",
  permissoes: ["whatsapp:atender"],
  tamanho_default: "S",
  essencial: false,
};

export async function fetchData(request) {
  const payload = await listarConversas(request, { status: "ABERTA", pageSize: 50 });
  const items = Array.isArray(payload) ? payload : (payload?.results || []);
  const total = items.reduce((s, c) => s + (Number(c.nao_lidas_count) || 0), 0);
  return { total, conversas: items.length };
}

export function Widget({ dados }) {
  const t = dados?.total ?? 0;
  return (
    <>
      <CardBody>
        <KpiValor style={{ color: t > 0 ? "var(--info-text)" : undefined }}>{t}</KpiValor>
        <KpiSub>
          {t > 0
            ? `não lidas em ${dados?.conversas ?? 0} conversa(s)`
            : "Nenhuma mensagem pendente."}
        </KpiSub>
      </CardBody>
      <CardFooter>
        <LinkLight as={Link} to="/whatsapp/inbox">Abrir inbox</LinkLight>
      </CardFooter>
    </>
  );
}
